<template>
  <div>
    <div class="top-contaion">
      <div class="header-contain">
        <router-link tag="a" to="/Home" class="header-left">
          <img src="../../static/logo.png" alt="前海高扬" title="前海高扬" />
        </router-link>
        <ul class="header-right">
          <li class="header-tab">
            <router-link
              tag="a"
              :to="{ path: '/' + item.tabName }"
              v-for="(item, index) in tabData"
              :key="index"
              class="tabName"
              :class="tabs == item.tabName ? 'tabActive' : 'tabName'"
              >{{ item.name }}</router-link
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabData: [
        { name: "首页", tabName: "Home" },
        { name: "公司简介", tabName: "About" },
        { name: "合作库", tabName: "Cooperation" },
        { name: "派单服务平台", tabName: "Service" },
        { name: "新闻中心", tabName: "News" },
        { name: "联系我们", tabName: "Contact" }
      ]
    };
  },
  created() {},
  computed: {
    tabs() {
      let url = "Home";
      if (this.$route.name) {
        url = this.$route.name;
      }
      return url;
    }
  },
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="less">
.top-contaion {
  width: 100%;
  height: 60px;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.06);
  .header-contain {
    width: 1170px;
    height: 60px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .header-left {
      width: 15%;
      height: 60px;
      display: flex;
      flex-direction: row;
      align-items: center;
      img {
        display: inline-block;
        cursor: pointer;
      }
    }
    .header-right {
      width: 85%;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      .header-tab {
        width: 60%;
        height: 60px;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        position: relative;
        .tabName {
          font-size: 14px;
          font-weight: 400;
          line-height: 24px;
          color: #666666;
          cursor: pointer;
          display: inline-block;
        }
        .tabName:hover {
          color: #3488ea;
        }
        .tabActive {
          display: inline-block;
          position: relative;
          font-size: 14px;
          line-height: 24px;
          color: #3488ea;
          font-weight: 400;
          &::after {
            content: "";
            width: 140%;
            height: 2px;
            position: absolute;
            left: -16%;
            bottom: -78%;
            background: #3488ea;
          }
        }
      }
    }
  }
}
a {
  text-decoration: none;
}
ul li {
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue